"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Container = _interopRequireDefault(require("@mui/material/Container"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Button = _interopRequireDefault(require("../../elements/Button/Button"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _MarkdownList = _interopRequireDefault(require("../../components/MarkdownList/MarkdownList"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _PageGrid = require("../../layouts/Skeletons/PageGrid/PageGrid");
var _excluded = ["headingCopy", "subheadingCopy", "buttonLabel", "solutionImageUrl", "solutionImageAlt", "buttonUrl", "listCopy"];
var _templateObject, _templateObject2, _templateObject3;
var HeroImage = _styledComponents.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  max-width: 100%;\n  margin-left: -25px;\n  margin-bottom: 20px;\n\n  @media (min-width: ", ") {\n    max-height: 60vh;\n    margin-left: -40px;\n    margin-bottom: 25px;\n    text-align: left;\n  }\n\n  @media (min-width: ", ") {\n    max-height: unset;\n    margin-left: -45px;\n    margin-bottom: 30px;\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    white: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    white: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var Solution = function Solution(_ref3) {
  var headingCopy = _ref3.headingCopy,
    subheadingCopy = _ref3.subheadingCopy,
    buttonLabel = _ref3.buttonLabel,
    solutionImageUrl = _ref3.solutionImageUrl,
    solutionImageAlt = _ref3.solutionImageAlt,
    buttonUrl = _ref3.buttonUrl,
    listCopy = _ref3.listCopy,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_PageGrid.PageGridStyles, Object.assign({
    justifyContent: "flex-start",
    heroBackgroundColor: 'var(--bf-core-teal)'
  }, props), _react.default.createElement(_Container.default, {
    maxWidth: false,
    style: {
      overflow: 'hidden'
    }
  }, _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: "flex-start"
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    justifyContent: "center"
  }, props), _react.default.createElement(StyledSectionHeading, props, headingCopy)), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    item: true,
    justifyContent: "flex-start",
    disableGutters: true,
    maxWidth: 'xl'
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 7,
    lg: 7,
    xl: 6
  }, props), _react.default.createElement(HeroImage, {
    src: solutionImageUrl,
    alt: solutionImageAlt
  })), _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 5,
    lg: 5
  }, props), _react.default.createElement(StyledSectionSubheading, props, subheadingCopy), _react.default.createElement(_MarkdownList.default, Object.assign({
    copy: listCopy,
    bfTextColor: "white"
  }, props)), _react.default.createElement(_Link.default, {
    href: buttonUrl
  }, _react.default.createElement(_Button.default, {
    pink: true
  }, " ", buttonLabel, " ")))))));
};
var _default = Solution;
exports.default = _default;